import {gql} from 'apollo-angular';


export const validateFilter = 'validateFilter';
export const validateFilterNameQuery = gql`
    query validateFilterName($filterName: String!) {
        validateFilter(filterName: $filterName)
    }
`;
